<mat-card>
  <mat-card-header>
    <mat-card-title>{{ data.camera.name }}</mat-card-title>
    <mat-card-subtitle *ngIf="data.camera.location">{{
      data.camera.location.name
    }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <sn-image-player
      class="sn-image-player"
      [autoplay]="true"
      [aspectRatio]="aspectRatio"
      [refreshTime]="0"
    >
      <fs-ai-box
        fsPlayerImage
        [xValue]="data.aiBox?.startX"
        [yValue]="data.aiBox?.startY"
        [widthValue]="data.aiBox?.width"
        [heightValue]="data.aiBox?.height"
        [resolution]="data.resolution"
        [meta]="data.meta"
      >
        <img [src]="data.snapshot" />
      </fs-ai-box>
      <sn-player-footer-section alignment="end" fsPlayerFooter>
        <sn-icon-button
          *ngIf="data.camera.playbackUrls && showIsInLoop"
          (click)="setViewClip(data.item, data)"
          [matTooltip]="'View Clip'"
          ><sn-icon>videocam</sn-icon></sn-icon-button
        >
      </sn-player-footer-section>
    </sn-image-player>
  </mat-card-content>
  <mat-card-footer>
    <sn-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()" class="kebabMenu">
      <sn-icon>more_vert</sn-icon>
    </sn-icon-button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="sendToVault(data.snapshot)">Add to Vault</button>
      <button mat-menu-item (click)="selectChannel(data.snapshot)">Share in Chat</button>
      <button
        mat-menu-item
        *ngIf="data.camera.playbackUrls && showIsInLoop"
        (click)="setViewClip(data.item, data)"
      >
        View Clip
      </button>
      <button mat-menu-item (click)="viewDetectionDetails()">View Detection Details</button>
      <button
        *ngIf="!reported || reporting"
        mat-menu-item
        matTooltip="Report as Incorrect"
        (click)="incorrectSentryResult(data.item, data)"
      >
        Report Detection
      </button>
      <button mat-menu-item matTooltip="Take a screenshot" (click)="clip(data.snapshot)">
        Screenshot
      </button>
    </mat-menu>
  </mat-card-footer>
</mat-card>
